export class MaterialOption {
  label: string;
  price: number;

  constructor(obj?: Partial<MaterialOption>) {
    this.label = String(obj?.label ?? '').trim();
    const parsed = parseFloat(String(obj?.price ?? 0));
    this.price = isNaN(parsed) ? 0 : Math.round(parsed * 100) / 100;
  }
}

export class Settings {
  _id: string;
  dutyAmount: number;
  nosepadsInstallAmount: number;
  drillMountAmount: number;
  restockingFeePercent: number;
  materials: MaterialOption[];

  constructor(obj?: Partial<Settings>) {
    this._id = obj?._id ?? 'system';
    this.dutyAmount = obj?.dutyAmount ?? 50;
    this.nosepadsInstallAmount = obj?.nosepadsInstallAmount ?? 0;
    this.drillMountAmount = obj?.drillMountAmount ?? 0;
    const restocking = parseFloat(String(obj?.restockingFeePercent ?? 15));
    this.restockingFeePercent =
      isNaN(restocking) || restocking < 0 ? 15 : restocking;
    this.materials = Array.isArray(obj?.materials)
      ? obj.materials.map((item) => new MaterialOption(item))
      : [];
  }
}
